import { AxiosInstance } from 'axios';
import { Result } from 'services/Result';

export class SubscriptionsAndPricingService {
  private axiosInstance: AxiosInstance;
  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  getShopCertificationTests = async () => {
    const response = await this.axiosInstance.get<Result<any[]>>(`api/shop-certification-tests`);
    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data;
    }
    throw Error('There was an internal error while fetching certificates.');
  };
}
